// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d2iC","footer":"styles_footer__3SgPL","passCodeTooltip":"styles_passCodeTooltip__3FeHo"};